import { render } from "./RIDetails.vue?vue&type=template&id=7ab7e15f&scoped=true"
import script from "./RIDetails.vue?vue&type=script&lang=js"
export * from "./RIDetails.vue?vue&type=script&lang=js"

import "./RIDetails.vue?vue&type=style&index=0&id=7ab7e15f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab7e15f"]])

export default __exports__